<template>
  <div class="mb-5">
    {{
      $t(
        "components.Calculations.Variants.ViewParts.SurchargeCashSalePriceTab.SiteSpecificSurcharges"
      )
    }}
  </div>
  <div class="grid">
    <CalcOutput
      :id="locationId"
      element-type="location"
      unit="%"
      :label="$t('entities.variant.fields.administrative_and_sales_costs_part')"
      :tooltip-label="
        $t(
          'entities.location.fields.administrative_and_sales_overhead_surcharge_percentage_location'
        )
      "
      field="administrative_and_sales_overhead_surcharge_percentage_location"
      outside-label />
    <CalcOutput
      :id="partId"
      hide-label
      :unit="$t('units.e_per_piece')"
      :label="$t('entities.variant.fields.administrative_and_sales_costs_part')"
      field="administrative_and_sales_costs_part" />

    <CalcOutput
      :id="locationId"
      field="research_and_development_overhead_surcharge_percentage_location"
      :label="$t('entities.variant.fields.research_and_development_costs_part')"
      :tooltip-label="
        $t(
          'entities.location.fields.research_and_development_overhead_surcharge_percentage_location'
        )
      "
      outside-label
      unit="%" />
    <CalcOutput
      :id="partId"
      field="research_and_development_costs_part"
      element-type="variant"
      :unit="$t('units.e_per_piece')"
      hide-label />

    <CalcOutput
      :id="locationId"
      field="calculated_venture_costs_surcharge_percentage_location"
      :label="$t('entities.variant.fields.calculated_venture_costs_part')"
      :tooltip-label="
        $t(
          'entities.location.fields.calculated_venture_costs_surcharge_percentage_location'
        )
      "
      outside-label
      unit="%" />
    <CalcOutput
      :id="partId"
      field="calculated_venture_costs_part"
      element-type="variant"
      :unit="$t('units.e_per_piece')"
      hide-label />

    <CalcOutput
      :id="locationId"
      field="flat_rate_surcharge_percentage_location"
      outside-label
      unit="%"
      :label="
        $t(
          'entities.variant.fields.flat_rate_surcharge_after_production_costs_part'
        )
      "
      :tooltip-label="
        $t('entities.location.fields.flat_rate_surcharge_percentage_location')
      " />
    <CalcOutput
      :id="partId"
      field="flat_rate_surcharge_after_production_costs_part"
      element-type="variant"
      hide-label
      :unit="$t('units.e_per_piece')" />

    <CalcOutput
      :id="partId"
      element-type="variant"
      field="location_specific_surcharges_after_production_costs_part"
      :unit="$t('units.e_per_piece')"
      outside-label
      class="single" />
  </div>
</template>

<script setup>
import CalcOutput from "@/components/Elements/CalcOutput.vue";

defineProps({
  partId: {
    type: String,
    required: true
  },
  locationId: {
    type: String,
    required: true
  }
});
</script>

<style lang="scss" scoped>
.grid {
  font-size: 85%;
  display: grid;
  row-gap: 10px;
  column-gap: 20px;
  grid-template-columns: [start] 2fr 1fr [end];
  align-items: center;
  width: 100%;

  .single {
    grid-column-start: start;
    grid-column-end: end;
  }
}
</style>
